module.exports = __webpack_public_path__ + "img/home.5dafcaee.svg";